// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesHub-page-BEflz {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.ServicesHub-wrap-xaMZc {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.ServicesHub-sec-mDupm {
  padding: 52px 0;
}

.ServicesHub-secTight-Dt72S {
  padding: 26px 0 0;
}

.ServicesHub-alt-A2HCQ {
  background: #f7f8f9;
}

.ServicesHub-h2-UXliL {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 800;
  margin: 0 0 24px;
}

/* Quick-jump chips */

.ServicesHub-jump-IRVYL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.ServicesHub-chip-JVipq {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 38px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: #fff0ef;
  color: var(--ink);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  -webkit-transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, border-color 0.16s, transform 0.16s;
  transition: background 0.16s, border-color 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.ServicesHub-chip-JVipq:hover {
  background: #ffe3e1;
  border-color: #f3c9cb;
  -webkit-transform: translateY(-1px);
      -ms-transform: translateY(-1px);
          transform: translateY(-1px);
}

/* Service cards */

.ServicesHub-grid-hjXBR {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.ServicesHub-card-XVlao {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 20px 22px;
  background: #fff;
  text-decoration: none;
  color: var(--ink);
  -webkit-transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.ServicesHub-card-XVlao:hover {
  -webkit-transform: translateY(-3px);
      -ms-transform: translateY(-3px);
          transform: translateY(-3px);
  border-color: #f3c9cb;
  -webkit-box-shadow: 0 16px 36px rgba(15, 18, 20, 0.08);
          box-shadow: 0 16px 36px rgba(15, 18, 20, 0.08);
}

.ServicesHub-card-XVlao:focus-visible {
  outline: 2px solid var(--red);
  outline-offset: 2px;
}

.ServicesHub-ic-fcqla {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.ServicesHub-ic-fcqla svg {
  width: 28px;
  height: 28px;
}

.ServicesHub-cardBody-n7Qla {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-width: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 3px;
}

.ServicesHub-cardName-Zcwl7 {
  font-size: 17px;
  font-weight: 800;
}

.ServicesHub-cardBlurb-H5YR4 {
  font-size: 14px;
  line-height: 1.45;
  color: var(--muted);
}

.ServicesHub-cardFrom-ctDX4 {
  font-size: 13px;
  font-weight: 700;
  color: var(--green);
  margin-top: 2px;
}

.ServicesHub-arrow-Gd5qn {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 20px;
  height: 20px;
  color: var(--muted);
  -webkit-transition: -webkit-transform 0.16s;
  transition: -webkit-transform 0.16s;
  transition: transform 0.16s;
  transition: transform 0.16s, -webkit-transform 0.16s;
}

.ServicesHub-card-XVlao:hover .ServicesHub-arrow-Gd5qn {
  -webkit-transform: translateX(3px);
      -ms-transform: translateX(3px);
          transform: translateX(3px);
  color: var(--red);
}

.ServicesHub-note-VCiIM {
  margin: 18px 0 0;
  font-size: 12px;
  color: var(--muted);
}

@media (max-width: 760px) {
  .ServicesHub-grid-hjXBR {
    grid-template-columns: 1fr;
  }
  .ServicesHub-sec-mDupm {
    padding: 40px 0;
  }
}

@media (prefers-color-scheme: dark) {
  .ServicesHub-page-BEflz {
    background: #14171a;
    color: #f3f4f6;
  }
  .ServicesHub-alt-A2HCQ {
    background: #1a1e22;
  }
  .ServicesHub-h2-UXliL,
  .ServicesHub-cardName-Zcwl7 {
    color: #f3f4f6;
  }
  .ServicesHub-cardBlurb-H5YR4,
  .ServicesHub-note-VCiIM {
    color: #9aa3ad;
  }
  .ServicesHub-card-XVlao {
    background: #1d2125;
    border-color: #2c3137;
    color: #f3f4f6;
  }
  .ServicesHub-ic-fcqla {
    background: rgba(232, 35, 43, 0.14);
  }
  .ServicesHub-chip-JVipq {
    background: rgba(232, 35, 43, 0.14);
    border-color: #2c3137;
    color: #f3f4f6;
  }
  .ServicesHub-chip-JVipq:hover {
    background: rgba(232, 35, 43, 0.24);
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/services-hub/ServicesHub.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;;AACrB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iFAAiE;EAAjE,yEAAiE;EAAjE,iEAAiE;EAAjE,0FAAiE;AACnE;;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,kBAAkB;;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,yFAAiE;EAAjE,iFAAiE;EAAjE,iEAAiE;EAAjE,oHAAiE;AACnE;;AACA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;EACrB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2B;EAA3B,mCAA2B;EAA3B,2BAA2B;EAA3B,oDAA2B;AAC7B;;AACA;EACE,kCAA0B;MAA1B,8BAA0B;UAA1B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,mCAAmC;EACrC;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 52px 0;\n}\n.secTight {\n  padding: 26px 0 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(24px, 4vw, 32px);\n  font-weight: 800;\n  margin: 0 0 24px;\n}\n\n/* Quick-jump chips */\n.jump {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n.chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid var(--line);\n  background: #fff0ef;\n  color: var(--ink);\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 0.16s, border-color 0.16s, transform 0.16s;\n}\n.chip:hover {\n  background: #ffe3e1;\n  border-color: #f3c9cb;\n  transform: translateY(-1px);\n}\n\n/* Service cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n.card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 20px 22px;\n  background: #fff;\n  text-decoration: none;\n  color: var(--ink);\n  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;\n}\n.card:hover {\n  transform: translateY(-3px);\n  border-color: #f3c9cb;\n  box-shadow: 0 16px 36px rgba(15, 18, 20, 0.08);\n}\n.card:focus-visible {\n  outline: 2px solid var(--red);\n  outline-offset: 2px;\n}\n.ic {\n  flex: 0 0 auto;\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ic svg {\n  width: 28px;\n  height: 28px;\n}\n.cardBody {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.cardName {\n  font-size: 17px;\n  font-weight: 800;\n}\n.cardBlurb {\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--muted);\n}\n.cardFrom {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--green);\n  margin-top: 2px;\n}\n.arrow {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  color: var(--muted);\n  transition: transform 0.16s;\n}\n.card:hover .arrow {\n  transform: translateX(3px);\n  color: var(--red);\n}\n\n.note {\n  margin: 18px 0 0;\n  font-size: 12px;\n  color: var(--muted);\n}\n\n@media (max-width: 760px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n  .sec {\n    padding: 40px 0;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .cardName {\n    color: #f3f4f6;\n  }\n  .cardBlurb,\n  .note {\n    color: #9aa3ad;\n  }\n  .card {\n    background: #1d2125;\n    border-color: #2c3137;\n    color: #f3f4f6;\n  }\n  .ic {\n    background: rgba(232, 35, 43, 0.14);\n  }\n  .chip {\n    background: rgba(232, 35, 43, 0.14);\n    border-color: #2c3137;\n    color: #f3f4f6;\n  }\n  .chip:hover {\n    background: rgba(232, 35, 43, 0.24);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ServicesHub-page-BEflz`,
	"wrap": `ServicesHub-wrap-xaMZc`,
	"sec": `ServicesHub-sec-mDupm`,
	"secTight": `ServicesHub-secTight-Dt72S`,
	"alt": `ServicesHub-alt-A2HCQ`,
	"h2": `ServicesHub-h2-UXliL`,
	"jump": `ServicesHub-jump-IRVYL`,
	"chip": `ServicesHub-chip-JVipq`,
	"grid": `ServicesHub-grid-hjXBR`,
	"card": `ServicesHub-card-XVlao`,
	"ic": `ServicesHub-ic-fcqla`,
	"cardBody": `ServicesHub-cardBody-n7Qla`,
	"cardName": `ServicesHub-cardName-Zcwl7`,
	"cardBlurb": `ServicesHub-cardBlurb-H5YR4`,
	"cardFrom": `ServicesHub-cardFrom-ctDX4`,
	"arrow": `ServicesHub-arrow-Gd5qn`,
	"note": `ServicesHub-note-VCiIM`
};
module.exports = ___CSS_LOADER_EXPORT___;
